import { log, LogLevel } from 'utils/LogUtil';
import axios from './axiosInstance';
import { Schedule } from 'common/models/types';

interface ScheduleResponse {
  error: boolean;
  data?: Schedule;
  message?: string;
}

interface SchedulesResponse {
  error: boolean;
  data?: Schedule[];
  message?: string;
}

export interface ScheduleFilterParams {
  dateFrom?: string;
  dateTo?: string;
  patientId?: number;
  doneOnly?: boolean;
  undoneOnly?: boolean;
}

export interface CreateScheduleParams {
  scheduledAt: string;
  notes?: string;
}

export interface UpdateScheduleParams {
  scheduledAt?: string;
  notes?: string | null;
  doneAt?: any; // truthy → 완료, falsy → 완료 취소
}

// 일정 목록 조회
export async function fetchSchedules(params?: ScheduleFilterParams): Promise<SchedulesResponse> {
  try {
    const response = await axios.get('/api/v1/patients/schedules', { params });
    return response.data;
  } catch (error) {
    log(LogLevel.ERROR, '일정 목록 조회 실패:', error);
    return { error: true, message: '일정 목록을 불러오는 데 실패했습니다.' };
  }
}

// 환자 일정 추가
export async function createSchedule(
  patientId: number,
  data: CreateScheduleParams,
): Promise<ScheduleResponse> {
  try {
    const response = await axios.post(`/api/v1/patients/${patientId}/schedules`, data);
    return response.data;
  } catch (error) {
    log(LogLevel.ERROR, '일정 추가 실패:', error);
    return { error: true, message: '일정을 추가하는 데 실패했습니다.' };
  }
}

// 일정 수정
export async function updateSchedule(
  scheduleId: number,
  data: UpdateScheduleParams,
): Promise<ScheduleResponse> {
  try {
    const response = await axios.put(`/api/v1/patients/schedules/${scheduleId}`, data);
    return response.data;
  } catch (error) {
    log(LogLevel.ERROR, '일정 수정 실패:', error);
    return { error: true, message: '일정을 수정하는 데 실패했습니다.' };
  }
}

// 일정 삭제
export async function deleteSchedule(scheduleId: number): Promise<ScheduleResponse> {
  try {
    const response = await axios.delete(`/api/v1/patients/schedules/${scheduleId}`);
    return response.data;
  } catch (error) {
    log(LogLevel.ERROR, '일정 삭제 실패:', error);
    return { error: true, message: '일정을 삭제하는 데 실패했습니다.' };
  }
}
